/*
 * df-pdp-tee-fallback.js
 *
 * La galeria de la ficha se pinta ya en "modo Teeinblue" cuando el producto
 * tiene el metafield `teeinblue.platform_product`: sin miniaturas propias y
 * con el hueco del escenario reservado. Eso quita el CLS (Search Console
 * marcaba 0,26 en movil en 40 URLs de producto desde el 1-sep) porque no hay
 * nada que mover cuando su script termina de montar.
 *
 * El precio de decidirlo en el servidor es que, si su script NO llega, el
 * cliente se queda con una sola foto y sin forma de ver el resto. Este fichero
 * es el seguro: si pasado el margen no hay galeria de Teeinblue montada,
 * devuelve la nuestra.
 *
 * Cuando salta el fallback SI hay salto de layout. Es intencionado: pasa solo
 * cuando su script ha fallado, y entre un salto y una ficha inservible, el
 * salto es mejor.
 *
 * --- ATAJO PARA LOS PRODUCTOS QUE YA NO SON DE TEEINBLUE (9-sep-2026) ---
 * Hay productos que conservan el metafield `teeinblue.platform_product` pero
 * que en realidad los personaliza el customizer propio de brandeate
 * (`personalizador.brandeate.es`, nodo `.dfp-personalizer`). Ahi Teeinblue no
 * monta NUNCA, asi que el cliente se comia los 6 segundos enteros con una
 * galeria de una sola foto: sin miniaturas, sin flechas y sin contador. Es lo
 * que se veia como «la galeria tarda mucho en cargar» en `mapa-estelar`.
 *
 * Si aparece `.dfp-personalizer`, ese producto es de brandeate y Teeinblue no
 * va a tomar la galeria: se devuelve la nuestra en ese mismo instante en vez
 * de esperar al margen. Comprobado que en un producto de Teeinblue de verdad
 * (`cuadro-mama-4-fotos`) ese nodo no existe, asi que no les afecta.
 *
 * El margen NO se toca. Medir aqui cuanto tarda Teeinblue en montar no vale:
 * el panel de navegador estrangula los temporizadores y los numeros salen
 * inflados. Bajarlo a ojo se lo cargaria en los productos que si son suyos.
 */
(function () {
  'use strict';

  var MARGEN_MS = 6000;

  function montada(gal) {
    // Dos señales: la clase que pone su script al tomar el contenedor, o
    // cualquier nodo suyo ya dentro del escenario.
    return gal.classList.contains('tee-gallery-wrapper') ||
           !!gal.querySelector('.tee-gallery-wrapper, .tee-mockup-item, .tee-thumbnails, canvas');
  }

  function revisar(gal) {
    if (montada(gal)) {
      gal.classList.remove('df-pdp__gallery--tee-fallo');
      return true;
    }
    return false;
  }

  // El customizer propio de brandeate. Si esta, la galeria no es de Teeinblue.
  function otroCustomizer() {
    return !!document.querySelector('.dfp-personalizer');
  }

  function vigilar(gal) {
    if (revisar(gal)) return;

    var obsDoc = null;

    function devolverLaNuestra() {
      if (montada(gal)) return;
      gal.classList.add('df-pdp__gallery--tee-fallo');
      clearTimeout(t);
      if (obsDoc) { obsDoc.disconnect(); obsDoc = null; }
    }

    // El observador de la galeria NO se desconecta al agotarse el margen: si
    // Teeinblue monta tarde, hay que quitarle el fallback igual. Antes se
    // desconectaba y la limpieza dependia solo de su evento propio.
    var obs = new MutationObserver(function () {
      if (revisar(gal)) { obs.disconnect(); clearTimeout(t); if (obsDoc) obsDoc.disconnect(); }
    });
    obs.observe(gal, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    // Su propio evento, cuando existe, es la señal mas fiable.
    document.addEventListener('teeinblue-event-component-injected', function () {
      if (revisar(gal)) { obs.disconnect(); clearTimeout(t); if (obsDoc) obsDoc.disconnect(); }
    });

    // Atajo: el customizer de brandeate ya esta, o llega en cuanto monte.
    if (otroCustomizer()) {
      devolverLaNuestra();
    } else {
      obsDoc = new MutationObserver(function () {
        if (otroCustomizer()) devolverLaNuestra();
      });
      obsDoc.observe(document.body, { childList: true, subtree: true });
    }

    var t = setTimeout(function () {
      if (obsDoc) { obsDoc.disconnect(); obsDoc = null; }
      if (!montada(gal)) gal.classList.add('df-pdp__gallery--tee-fallo');
    }, MARGEN_MS);
  }

  function arrancar() {
    var gals = document.querySelectorAll('[data-df-tee-espera]');
    for (var i = 0; i < gals.length; i++) vigilar(gals[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
